import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native'
import { useRouter } from 'expo-router'
import { colors, fonts } from '../lib/theme'
import { useThemeColors } from '../lib/useThemeColors'

const SECTIONS = [
  {
    title: 'Titolare del Trattamento',
    content: `Aljosa Vella\nVia Nicola Marchese 26, 00141 Roma\nEmail: virtuacycling@gmail.com`,
  },
  {
    title: 'Dati Personali Raccolti',
    content: `Questa applicazione raccoglie i seguenti dati personali:\n\n• Email e nickname: forniti volontariamente durante la registrazione\n• Dati di gioco: le scelte dei corridori (pick) effettuate nell'applicazione\n• Token dispositivo: per l'invio di notifiche push tramite OneSignal\n• Dati di accesso Google: in caso di login tramite Google OAuth (nome, email, foto profilo)`,
  },
  {
    title: 'Finalità del Trattamento',
    content: `I dati raccolti sono utilizzati esclusivamente per:\n\n• Fornire e gestire il servizio di fantasy cycling\n• Identificare l'utente e consentire l'accesso all'applicazione\n• Inviare notifiche push relative alle gare (con consenso esplicito dell'utente)\n• Calcolare classifiche e punteggi`,
  },
  {
    title: 'Base Giuridica',
    content: `Il trattamento è basato su:\n• Esecuzione del contratto: per fornire il servizio richiesto dall'utente\n• Consenso: per l'invio di notifiche push (revocabile in qualsiasi momento)`,
  },
  {
    title: 'Servizi Terzi Utilizzati',
    content: `• Supabase (database e autenticazione) — supabase.com/privacy\n• Vercel (hosting) — vercel.com/legal/privacy-policy\n• OneSignal (notifiche push) — onesignal.com/privacy_policy\n• Google OAuth (accesso con Google) — policies.google.com/privacy`,
  },
  {
    title: 'Cookie',
    content: `Questa applicazione utilizza esclusivamente cookie tecnici necessari al funzionamento del servizio (gestione della sessione di autenticazione). Non vengono utilizzati cookie di profilazione, analitici o pubblicitari.`,
  },
  {
    title: 'Notifiche Push',
    content: `Le notifiche push vengono inviate tramite OneSignal solo previo esplicito consenso dell'utente. Il consenso può essere revocato in qualsiasi momento dalle impostazioni del profilo nell'applicazione o dalle impostazioni del dispositivo.`,
  },
  {
    title: 'Conservazione dei Dati',
    content: `I dati personali sono conservati per il tempo necessario all'erogazione del servizio e comunque non oltre la cancellazione dell'account da parte dell'utente. In caso di inattività prolungata (oltre 24 mesi), i dati potranno essere eliminati.`,
  },
  {
    title: "Diritti dell'Utente (GDPR)",
    content: `In conformità al Regolamento UE 2016/679 (GDPR), l'utente ha diritto di:\n\n• Accedere ai propri dati personali\n• Rettificare dati inesatti\n• Richiedere la cancellazione dei dati ("diritto all'oblio")\n• Opporsi al trattamento\n• Richiedere la portabilità dei dati\n• Revocare il consenso in qualsiasi momento\n\nPer esercitare questi diritti, contattare: virtuacycling@gmail.com`,
  },
  {
    title: 'Sicurezza',
    content: `I dati sono archiviati su infrastruttura Supabase con crittografia in transito (HTTPS/TLS) e a riposo. L'accesso ai dati è protetto da autenticazione e row-level security.`,
  },
  {
    title: 'Modifiche alla Privacy Policy',
    content: `Il Titolare si riserva il diritto di modificare questa policy. Le modifiche saranno comunicate agli utenti tramite notifica nell'applicazione o via email.`,
  },
]

export default function Privacy() {
  const tc = useThemeColors()
  const styles = useMemo(() => makeStyles(tc), [tc])
  const router = useRouter()

  return (
    <ScrollView style={[styles.container, { backgroundColor: tc.bg }]} contentContainerStyle={{ padding: 20, paddingBottom: 60 }}>

      {/* Back */}
      <TouchableOpacity style={styles.backBtn} onPress={() => router.back()}>
        <Text style={styles.backText}>← Indietro</Text>
      </TouchableOpacity>

      {/* Titolo */}
      <Text style={[styles.pageTitle, { color: tc.text }]}>Privacy & Cookie Policy</Text>
      <Text style={[styles.pageDate, { color: tc.textMuted }]}>Ultima modifica: Aprile 2026</Text>

      {/* Sezioni */}
      {SECTIONS.map((section, i) => (
        <View key={i} style={styles.section}>
          <View style={styles.sectionHeader}>
            <View style={styles.sectionBar} />
            <Text style={styles.sectionTitle}>{section.title}</Text>
          </View>
          <Text style={[styles.sectionContent, { color: tc.textMuted }]}>{section.content}</Text>
        </View>
      ))}

      {/* Footer */}
      <TouchableOpacity style={styles.footerBtn} onPress={() => router.back()}>
        <Text style={styles.footerBtnText}>← Torna al login</Text>
      </TouchableOpacity>

    </ScrollView>
  )
}

const makeStyles = (tc) => StyleSheet.create({
  container:      { flex: 1 },
  backBtn:        { marginBottom: 24 },
  backText:       { fontSize: 13, color: tc.textMuted },
  pageTitle:      { fontFamily: fonts.condensedBold, fontSize: 32, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 },
  pageDate:       { fontSize: 12, marginBottom: 32 },
  section:        { marginBottom: 28 },
  sectionHeader:  { flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 10 },
  sectionBar:     { width: 3, height: 16, backgroundColor: tc.rosa, borderRadius: 2 },
  sectionTitle:   { fontFamily: fonts.condensedBold, fontSize: 17, color: tc.rosaText, textTransform: 'uppercase', letterSpacing: 0.5, flex: 1 },
  sectionContent: { fontSize: 13, lineHeight: 22 },
  footerBtn:      { marginTop: 40, paddingTop: 20, borderTopWidth: 1, borderTopColor: tc.border, alignItems: 'center' },
  footerBtnText:  { fontSize: 13, color: tc.rosaText, fontFamily: fonts.condensedBold },
})
